import script from "./SummaryCards.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryCards.vue?vue&type=script&setup=true&lang=js"

import "./SummaryCards.vue?vue&type=style&index=0&id=7fae843e&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fae843e"]])

export default __exports__